import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useCurrentUser } from '../api/session';
import { ErrorState, LoadingState } from '../components/states';

/** Разделы открываются только после входа. Права на данные проверяет сервер. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const me = useCurrentUser();
  const location = useLocation();

  if (me.isPending) {
    return (
      <main className="login">
        <LoadingState label="Проверяю вход" />
      </main>
    );
  }
  if (me.isError) {
    return (
      <main className="login">
        <ErrorState title="Не удалось проверить вход" error={me.error} onRetry={() => void me.refetch()} />
      </main>
    );
  }
  if (!me.data) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
